import React from 'react';
import { NavLink } from 'react-router-dom';

import { ROUTE_CARTS } from '@/common/constants';
import {
  CartNavLinkDefaultProps,
  CartNavLinkPropTypes,
} from '@/ebat/components/blocks/Header/CartButton/CartNavLink/CartNavLink.proptypes';

const CartNavLink = ({ className, children, id }) => (
  <NavLink
    className={className}
    to={`${ROUTE_CARTS}/${id}`}
    data-qa-id="header-add-to-cart-active"
  >
    {children}
  </NavLink>
);

CartNavLink.defaultProps = {
  ...CartNavLinkDefaultProps,
};

CartNavLink.propTypes = {
  ...CartNavLinkPropTypes,
};

export default CartNavLink;
